import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import * as PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { NavigationDirections } from '../../state';

/**
 * Container for transitioning a group of elements under a div element, useful for animating.
 * Attaches classes based on @property 'name', to be used in conjuction with AppContainer and / or
 * transition mixin
 */

//TODO: need to implement a context here so children can know when transitions are done prior calling dispatch functions, it will help fix the hack done in CardBuilder.jsx
const TransitionContainer = ({
  children,
  className,
  component,
  isLoadingNextPage,
  transitionKey,
  name = 'component',
  timeout = 1250,
}) => {
  useEffect(() => {
    if (isLoadingNextPage) {
      setCurrentPageTransition(isLoadingNextPage);
      setTimeout(() => setCurrentPageTransition(false), timeout);
    }
  }, [isLoadingNextPage]);

  const [currentPageTransition, setCurrentPageTransition] = useState(false);
  const containerClasses = classnames(className, 'transition-container');
  const transitionClasses = classnames(
    `transition-for-${name}`,
    {
      ['transition-content--reverse']:
        currentPageTransition === NavigationDirections.BACK,
      ['transition-content--forward']:
        currentPageTransition === NavigationDirections.FORWARD,
    },
    name
  );

  return (
    <TransitionGroup className={containerClasses} {...(component && { component })}>
      <CSSTransition
        key={transitionKey}
        classNames={transitionClasses}
        timeout={{
          appear: timeout,
          enter: timeout,
          exit: timeout,
        }}
      >
        {children}
      </CSSTransition>
    </TransitionGroup>
  );
};

TransitionContainer.propTypes = {
  className: PropTypes.string.isRequired,
  component: PropTypes.string,
  isLoadingNextPage: PropTypes.any,
  transitionKey: PropTypes.string,
  name: PropTypes.string,
  timeout: PropTypes.number,
  children: PropTypes.any
};
export default TransitionContainer;
